/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "včera",
        "-2": "predvčerom",
        "0": "dnes",
        "1": "zajtra",
        "2": "pozajtra",
        "future": {
          "few": "o {0} dni",
          "many": "o {0} dňa",
          "one": "o {0} deň",
          "other": "o {0} dní"
        },
        "past": {
          "few": "pred {0} dňami",
          "many": "pred {0} dňa",
          "one": "pred {0} dňom",
          "other": "pred {0} dňami"
        }
      },
      "day-narrow": {
        "-1": "včera",
        "-2": "predvčerom",
        "0": "dnes",
        "1": "zajtra",
        "2": "pozajtra",
        "future": {
          "few": "o {0} d.",
          "many": "o {0} d.",
          "one": "o {0} d.",
          "other": "o {0} d."
        },
        "past": {
          "few": "pred {0} d.",
          "many": "pred {0} d.",
          "one": "pred {0} d.",
          "other": "pred {0} d."
        }
      },
      "day-short": {
        "-1": "včera",
        "-2": "predvčerom",
        "0": "dnes",
        "1": "zajtra",
        "2": "pozajtra",
        "future": {
          "few": "o {0} d.",
          "many": "o {0} d.",
          "one": "o {0} d.",
          "other": "o {0} d."
        },
        "past": {
          "few": "pred {0} d.",
          "many": "pred {0} d.",
          "one": "pred {0} d.",
          "other": "pred {0} d."
        }
      },
      "hour": {
        "0": "v tejto hodine",
        "future": {
          "few": "o {0} hodiny",
          "many": "o {0} hodiny",
          "one": "o {0} hodinu",
          "other": "o {0} hodín"
        },
        "past": {
          "few": "pred {0} hodinami",
          "many": "pred {0} hodinou",
          "one": "pred {0} hodinou",
          "other": "pred {0} hodinami"
        }
      },
      "hour-narrow": {
        "0": "v tejto hodine",
        "future": {
          "few": "o {0} h",
          "many": "o {0} h",
          "one": "o {0} h",
          "other": "o {0} h"
        },
        "past": {
          "few": "pred {0} h",
          "many": "pred {0} h",
          "one": "pred {0} h",
          "other": "pred {0} h"
        }
      },
      "hour-short": {
        "0": "v tejto hodine",
        "future": {
          "few": "o {0} h",
          "many": "o {0} h",
          "one": "o {0} h",
          "other": "o {0} h"
        },
        "past": {
          "few": "pred {0} h",
          "many": "pred {0} h",
          "one": "pred {0} h",
          "other": "pred {0} h"
        }
      },
      "minute": {
        "0": "v tejto minúte",
        "future": {
          "few": "o {0} minúty",
          "many": "o {0} minúty",
          "one": "o {0} minútu",
          "other": "o {0} minút"
        },
        "past": {
          "few": "pred {0} minútami",
          "many": "pred {0} minúty",
          "one": "pred {0} minútou",
          "other": "pred {0} minútami"
        }
      },
      "minute-narrow": {
        "0": "v tejto minúte",
        "future": {
          "few": "o {0} min",
          "many": "o {0} min",
          "one": "o {0} min",
          "other": "o {0} min"
        },
        "past": {
          "few": "pred {0} min",
          "many": "pred {0} min",
          "one": "pred {0} min",
          "other": "pred {0} min"
        }
      },
      "minute-short": {
        "0": "v tejto minúte",
        "future": {
          "few": "o {0} min",
          "many": "o {0} min",
          "one": "o {0} min",
          "other": "o {0} min"
        },
        "past": {
          "few": "pred {0} min",
          "many": "pred {0} min",
          "one": "pred {0} min",
          "other": "pred {0} min"
        }
      },
      "month": {
        "-1": "minulý mesiac",
        "0": "tento mesiac",
        "1": "budúci mesiac",
        "future": {
          "few": "o {0} mesiace",
          "many": "o {0} mesiaca",
          "one": "o {0} mesiac",
          "other": "o {0} mesiacov"
        },
        "past": {
          "few": "pred {0} mesiacmi",
          "many": "pred {0} mesiaca",
          "one": "pred {0} mesiacom",
          "other": "pred {0} mesiacmi"
        }
      },
      "month-narrow": {
        "-1": "minulý mes.",
        "0": "tento mes.",
        "1": "budúci mes.",
        "future": {
          "few": "o {0} mes.",
          "many": "o {0} mes.",
          "one": "o {0} mes.",
          "other": "o {0} mes."
        },
        "past": {
          "few": "pred {0} mes.",
          "many": "pred {0} mes.",
          "one": "pred {0} mes.",
          "other": "pred {0} mes."
        }
      },
      "month-short": {
        "-1": "minulý mes.",
        "0": "tento mes.",
        "1": "budúci mes.",
        "future": {
          "few": "o {0} mes.",
          "many": "o {0} mes.",
          "one": "o {0} mes.",
          "other": "o {0} mes."
        },
        "past": {
          "few": "pred {0} mes.",
          "many": "pred {0} mes.",
          "one": "pred {0} mes.",
          "other": "pred {0} mes."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "minulý štvrťrok",
        "0": "tento štvrťrok",
        "1": "budúci štvrťrok",
        "future": {
          "few": "o {0} štvrťroky",
          "many": "o {0} štvrťroka",
          "one": "o {0} štvrťrok",
          "other": "o {0} štvrťrokov"
        },
        "past": {
          "few": "pred {0} štvrťrokmi",
          "many": "pred {0} štvrťroka",
          "one": "pred {0} štvrťrokom",
          "other": "pred {0} štvrťrokmi"
        }
      },
      "quarter-narrow": {
        "-1": "minulý štvrťr.",
        "0": "tento štvrťr.",
        "1": "budúci štvrťr.",
        "future": {
          "few": "o {0} štvrťr.",
          "many": "o {0} štvrťr.",
          "one": "o {0} štvrťr.",
          "other": "o {0} štvrťr."
        },
        "past": {
          "few": "pred {0} štvrťr.",
          "many": "pred {0} štvrťr.",
          "one": "pred {0} štvrťr.",
          "other": "pred {0} štvrťr."
        }
      },
      "quarter-short": {
        "-1": "minulý štvrťr.",
        "0": "tento štvrťr.",
        "1": "budúci štvrťr.",
        "future": {
          "few": "o {0} štvrťr.",
          "many": "o {0} štvrťr.",
          "one": "o {0} štvrťr.",
          "other": "o {0} štvrťr."
        },
        "past": {
          "few": "pred {0} štvrťr.",
          "many": "pred {0} štvrťr.",
          "one": "pred {0} štvrťr.",
          "other": "pred {0} štvrťr."
        }
      },
      "second": {
        "0": "teraz",
        "future": {
          "few": "o {0} sekundy",
          "many": "o {0} sekundy",
          "one": "o {0} sekundu",
          "other": "o {0} sekúnd"
        },
        "past": {
          "few": "pred {0} sekundami",
          "many": "pred {0} sekundy",
          "one": "pred {0} sekundou",
          "other": "pred {0} sekundami"
        }
      },
      "second-narrow": {
        "0": "teraz",
        "future": {
          "few": "o {0} s",
          "many": "o {0} s",
          "one": "o {0} s",
          "other": "o {0} s"
        },
        "past": {
          "few": "pred {0} s",
          "many": "pred {0} s",
          "one": "pred {0} s",
          "other": "pred {0} s"
        }
      },
      "second-short": {
        "0": "teraz",
        "future": {
          "few": "o {0} s",
          "many": "o {0} s",
          "one": "o {0} s",
          "other": "o {0} s"
        },
        "past": {
          "few": "pred {0} s",
          "many": "pred {0} s",
          "one": "pred {0} s",
          "other": "pred {0} s"
        }
      },
      "week": {
        "-1": "minulý týždeň",
        "0": "tento týždeň",
        "1": "budúci týždeň",
        "future": {
          "few": "o {0} týždne",
          "many": "o {0} týždňa",
          "one": "o {0} týždeň",
          "other": "o {0} týždňov"
        },
        "past": {
          "few": "pred {0} týždňami",
          "many": "pred {0} týždňa",
          "one": "pred {0} týždňom",
          "other": "pred {0} týždňami"
        }
      },
      "week-narrow": {
        "-1": "minulý týž.",
        "0": "tento týž.",
        "1": "budúci týž.",
        "future": {
          "few": "o {0} týž.",
          "many": "o {0} týž.",
          "one": "o {0} týž.",
          "other": "o {0} týž."
        },
        "past": {
          "few": "pred {0} týž.",
          "many": "pred {0} týž.",
          "one": "pred {0} týž.",
          "other": "pred {0} týž."
        }
      },
      "week-short": {
        "-1": "minulý týž.",
        "0": "tento týž.",
        "1": "budúci týž.",
        "future": {
          "few": "o {0} týž.",
          "many": "o {0} týž.",
          "one": "o {0} týž.",
          "other": "o {0} týž."
        },
        "past": {
          "few": "pred {0} týž.",
          "many": "pred {0} týž.",
          "one": "pred {0} týž.",
          "other": "pred {0} týž."
        }
      },
      "year": {
        "-1": "minulý rok",
        "0": "tento rok",
        "1": "budúci rok",
        "future": {
          "few": "o {0} roky",
          "many": "o {0} roka",
          "one": "o {0} rok",
          "other": "o {0} rokov"
        },
        "past": {
          "few": "pred {0} rokmi",
          "many": "pred {0} roka",
          "one": "pred {0} rokom",
          "other": "pred {0} rokmi"
        }
      },
      "year-narrow": {
        "-1": "minulý rok",
        "0": "tento rok",
        "1": "budúci rok",
        "future": {
          "few": "o {0} r.",
          "many": "o {0} r.",
          "one": "o {0} r.",
          "other": "o {0} r."
        },
        "past": {
          "few": "pred {0} r.",
          "many": "pred {0} r.",
          "one": "pred {0} r.",
          "other": "pred {0} r."
        }
      },
      "year-short": {
        "-1": "minulý rok",
        "0": "tento rok",
        "1": "budúci rok",
        "future": {
          "few": "o {0} r.",
          "many": "o {0} r.",
          "one": "o {0} r.",
          "other": "o {0} r."
        },
        "past": {
          "few": "pred {0} r.",
          "many": "pred {0} r.",
          "one": "pred {0} r.",
          "other": "pred {0} r."
        }
      }
    },
    "locale": "sk"
  });
}